import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import ItemBox from '../../../components/itens/item';


function ConcursosScreen() {
    return (
        <Fragment>
            <Head titulo="Concursos Públicos realizados pela Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1} lg={4}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/folha'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={3}>
                    <Col>
                        <ItemBox
                            titulo={"2001"}
                            descricao={<Fragment>Clique aqui e veja o edital e resultado final do Concurso realizado em 2001<br /><br /></Fragment>}
                            awesome={"faCalendar"}
                            link={"concursos/2001"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"2010"}
                            descricao={<Fragment>Clique aqui e veja o edital e resultado final do Concurso realizado em 2010<br /><br /></Fragment>}
                            awesome={"faCalendar"}
                            link={"concursos/2010"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"2012"}
                            descricao={<Fragment>Clique aqui e veja o edital e resultado final do Concurso realizado em 2012<br /><br /></Fragment>}
                            awesome={"faCalendar"}
                            link={"concursos/2012"}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ConcursosScreen;